import { render, staticRenderFns } from "./StujapaneseTable.vue?vue&type=template&id=a175d142&scoped=true&"
import script from "./StujapaneseTable.vue?vue&type=script&lang=js&"
export * from "./StujapaneseTable.vue?vue&type=script&lang=js&"
import style0 from "./StujapaneseTable.vue?vue&type=style&index=0&id=a175d142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a175d142",
  null
  
)

export default component.exports